import { SET_OPTIONS } from './types'

const initialState = {
  options: {},
}

const bucketReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_OPTIONS:
      return {
        ...state,
        options: { ...state?.options, ...payload },
      }

    default:
      return state
  }
}

export default bucketReducer
